import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories } from '../../actions/categoryAction';
import { Box, Grid, Typography, styled } from '@mui/material';
import { Link } from 'react-router-dom';

const CategoryItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2),
  transition: 'transform 0.2s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

const Categories = () => {

    const dispatch = useDispatch();
    const { categories } = useSelector((state) => state.categories);

    useEffect(() => {
        dispatch(getCategories());
    }, [dispatch]);

    const getLink = (category) => {
        if (category.children && category.children.length > 0) {
            return `/categories/${category.name}`;
        }
        return `/search?category=${category.name}`;
    }

    return (
        <Box
            sx={{
                display: { xs: 'block', sm: 'block' },
                mt: 5,
                mb: 2,
                minWidth: '100%',
                py: 3,
                textAlign: 'center',
            }}
        >
            <Grid container spacing={3} justifyContent="space-around">
                {categories && categories.map((category, i) => (
                    <Grid item key={i}>
                        <Link to={getLink(category)} style={{ textDecoration: 'none' }}>
                            <CategoryItem>
                                <Box
                                    component="img"
                                    src={category.logo.url}
                                    alt={category.name}
                                    className="neon-glow"
                                    sx={{ height: 80, width: 80, objectFit: 'contain', mb: 1 }}
                                />
                                <Typography
                                    variant="subtitle1"
                                    sx={{ color: 'text.primary', fontWeight: 500, '&:hover': { color: 'primary.main' } }}
                                >
                                    {category.name}
                                </Typography>
                            </CategoryItem>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
export default Categories;
